export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY =
  '/organizations/{organizationId}/contents-likes';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_ADMIN_PATH_KEY =
  '/organizations/{organizationId}/contents-likes/admin';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_PATH_KEY =
  '/organizations/{organizationId}/contents-likes/{contentHash}';
export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY =
  '/organizations/{organizationId}/contents-likes/{contentHash}/users';
